export default "__VITE_ASSET__DXVDpLVO__"